export default "__VITE_ASSET__CCerZ8wO__"